import { useLanguageContext } from '@hooks/useLanguageContext';

export const ProtocolWindowOptions = () => {
  const { dictionary } = useLanguageContext();

  return [
    {
      value: '0',
      label: dictionary.protocolWindow.zeroDays,
    },
    {
      value: '1',
      label: dictionary.protocolWindow.oneDay,
    },
    {
      value: '2',
      label: dictionary.protocolWindow.twoDays,
    },
    {
      value: '3',
      label: dictionary.protocolWindow.threeDays,
    },
    {
      value: '4',
      label: dictionary.protocolWindow.fourDays,
    },
    {
      value: '5',
      label: dictionary.protocolWindow.fiveDays,
    },
    {
      value: '6',
      label: dictionary.protocolWindow.sixDays,
    },
    {
      value: '7',
      label: dictionary.protocolWindow.sevenDays,
    },
    {
      value: '8',
      label: dictionary.protocolWindow.eightDays,
    },
    {
      value: '9',
      label: dictionary.protocolWindow.nineDays,
    },
    {
      value: '10',
      label: dictionary.protocolWindow.tenDays,
    },
    {
      value: '11',
      label: dictionary.protocolWindow.elevenDays,
    },
    {
      value: '12',
      label: dictionary.protocolWindow.twelveDays,
    },
    {
      value: '13',
      label: dictionary.protocolWindow.thirteenDays,
    },
    {
      value: '14',
      label: dictionary.protocolWindow.fourteenDays,
    },
  ];
};
